module.exports = __webpack_public_path__ + "static/osiris_04-1c9776b0ca3fa4a38eb5045e32c9d57a.jpg";